import { FC } from "react";
import { useAppSelector } from "slice";
import { useGetAgencyDataQuery } from "slice/user";
import {
    CoverImage,
    CoverImageWrapper,
    ProfileImage,
    ProfileImageContainer,
} from "../HighLight.styled";
import { useImageSection } from "./useImageSection";

export const ImageSection: FC<{ agency_logo?: string }> = ({ agency_logo }) => {
    const { images, handleError } = useImageSection();
    const { is_agency, id } = useAppSelector((state) => state.user);

    const { data: agencyData } = useGetAgencyDataQuery(
        { user_id: id ?? "" },
        { skip: !is_agency || (agency_logo ? true : false) }
    );

    const profileImageUrl =
        is_agency && agencyData?.company_logo
            ? agencyData.company_logo
            : images.profile?.url || "";

    return (
        <>
            <CoverImageWrapper>
                <CoverImage
                    src={agency_logo ? "" : images.cover?.url || ""}
                    onError={handleError}
                />
                <ProfileImageContainer>
                    <ProfileImage
                        src={agency_logo ? agency_logo : profileImageUrl}
                        onError={handleError}
                    />
                </ProfileImageContainer>
            </CoverImageWrapper>
        </>
    );
};
